// TestContent.js
import React from 'react';

const Projects = () => {
  return (
    <div>
      <h1>Projects</h1>
      <p>This content is coming from the TestContent component.</p>
    </div>
  );
};

export default Projects;